module.exports = __webpack_public_path__ + "static/img/promotions.abfb842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/tiles/promotions.png
// module id = PhO7
// module chunks = 1